import ImgWithSignedUrl from "components/SignedUrl/ImgWithSignedUrl";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import { truncateString } from "utils/UtilityFuncs";

function CustomerDetailsColumn({
  customerDetails,
  refreshFunc,
  setSelectedCustomer,
}) {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));

  /*   ALL STATES
   ********************************************* */
  const [formData, setFormData] = useState({ ...customerDetails });
  const [customerDetailsModal, setCustomerDetailsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [filesList, setFilesList] = useState([]);

  /*   ALL FUNCTIONS
   ********************************************* */
  const updateCustomerDetails = async (e) => {
    e.preventDefault();

    const newFormData = new FormData();

    for (let i = 0; i < filesList.length; i++) {
      newFormData.append("files", filesList[i]?.file);
    }

    let updatedData = {
      ...formData,
      paymentTermsId:
        formData.paymentTermsId === "null" ? null : formData.paymentTermsId,
      discountId: formData.discountId === "null" ? null : formData.discountId,
      id: customerDetails.id,
    };
    newFormData.append("updatedData", JSON.stringify(updatedData));

    let updatedFilesList = filesList.map((item) => {
      const folder =
        item?.title === "approvalImage"
          ? `kms/customer/${customerDetails?.id}/approvalImages`
          : `kms/customer/${customerDetails?.id}/brandNeckLabels`;
      return {
        folder,
        originalname: item?.fileName,
        title: item?.title,
      };
    });
    newFormData.append("filesList", JSON.stringify(updatedFilesList));
    setIsLoading(true);
    setSelectedCustomer(null);

    try {
      const { data } = await API.patch("/customers", newFormData, {
        headers: {
          "x-access-token": user?.accessToken,
          "Content-Type": "multipart/form-data",
        },
      });
      if (data.success) {
        let customers = await refreshFunc();
        let updatedCustomer = customers.find(
          (cust) => cust.id === customerDetails.id,
        );
        setSelectedCustomer(updatedCustomer);
        setIsLoading(false);
        setCustomerDetailsModal(false);
        return;
      }
      dispatch(
        setNotification({
          message: data,
          type: "error",
        }),
      );
    } catch (err) {
      setIsLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const handleFileSelect = (e) => {
    let { id, name } = e.target;
    id = parseInt(id);
    let file = e.target.files[0];
    // Only Allow png, jpg, jpeg files
    if (
      file.type !== "image/png" &&
      file.type !== "image/jpg" &&
      file.type !== "image/jpeg"
    ) {
      e.target.value = null;
      return dispatch(
        setNotification({
          message: "Only png, jpg, jpeg files are allowed",
          type: "error",
        }),
      );
    }

    let fileName = file.name;

    // Check if file with same id is present
    let isPresent = filesList.find((item) => item.id === id);
    if (isPresent) {
      let updatedFilesList = filesList.map((item) => {
        if (item.id === id) {
          return { ...item, file, fileName };
        }
        return item;
      });
      setFilesList(updatedFilesList);
    } else {
      setFilesList((prev) => {
        return [
          ...prev,
          {
            id,
            title: name,
            file,
            fileName,
          },
        ];
      });
    }
  };

  const deleteNeckLabel = async (key, field = "brandNeckLabel") => {
    try {
      setIsLoading(true);
      const { data } = await API.post(
        "/customers/delete-neck-label",
        {
          id: customerDetails?.id,
          file: key,
          field,
        },
        { headers: authHeader() },
      );
      console.log(data);
      await refreshFunc();
      dispatch(
        setNotification({
          message: data,
          type: "error",
        }),
      );
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  useEffect(() => {
    setFormData(customerDetails);
  }, [customerDetails]);

  return (
    <div className="d-flex flex-column w-100 py-2">
      <div className="d-flex justify-content-between align-items-center w-100 mb-1">
        <h4 className="border-bottom border-secondary">Profile</h4>
        <div className="ms-2">
          <button
            className="btn d-flex justify-content-center align-items-center btn-sm btn-success"
            style={{ width: 28, height: 28 }}
            onClick={() => {
              setCustomerDetailsModal(true);
              setFormData(customerDetails);
            }}
          >
            <i className="mdi fs-5 mdi-pencil"></i>
          </button>
        </div>
      </div>

      <div className="container-fluid px-0">
        <div className="row mb-1 align-items-center">
          <div className="col-5">External Customer ID</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.externalCustomerId
              ? customerDetails?.externalCustomerId
              : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Website</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.website ? customerDetails?.website : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Customer Reference</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.customerReference
              ? customerDetails?.customerReference
              : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Customer Type</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.customerType
              ? customerDetails?.customerType
              : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Custom Field 1</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.customField1
              ? customerDetails?.customField1
              : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Custom Field 2</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.customField2
              ? customerDetails?.customField2
              : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Custom Field 3</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.customField3
              ? customerDetails?.customField3
              : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Order Notes</div>
          <div className="col-1">:</div>
          <div className="col-6 text-truncate">
            {customerDetails?.orderNotes ? customerDetails?.orderNotes : "-"}
          </div>
        </div>
        <hr />
        {/* Both of these are just "is something attached?". A thumbnail was
            shown here before, which read as decoration rather than an answer
            and is useless for the approval banner anyway -- that one is
            2400x300, so a 30px square of it shows nothing. The images
            themselves are viewable and replaceable in the edit modal. */}
        <div className="row mb-1 align-items-center">
          <div className="col-5">Brand Neck Label</div>
          <div className="col-1">:</div>
          <div className="col-6">
            {customerDetails?.brandNeckLabel ? "Yes" : "-"}
          </div>
        </div>
        <div className="row mb-1 align-items-center">
          <div className="col-5">Approval Image</div>
          <div className="col-1">:</div>
          <div className="col-6">
            {customerDetails?.approvalImage ? "Yes" : "-"}
          </div>
        </div>
      </div>

      <Modal
        show={customerDetailsModal}
        onHide={() => setCustomerDetailsModal(false)}
        size="lg"
      >
        <Modal.Body>
          <form onSubmit={updateCustomerDetails}>
            <div className="row p-3 pt-1">
              <div className="">
                <h4 className="">Customer Details</h4>
              </div>
              <hr className="mb-3 mt-0" />
              <div className="col-12 mb-2">
                <div className="row mb-2">
                  <label className="col-3 my-auto px-0">Customer Name</label>
                  <div className="col-9">
                    <input
                      type="text"
                      value={formData?.customerName}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          customerName: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="Enter Customer Name"
                    />
                  </div>
                </div>
                <div className="row mb-2">
                  <label className="col-3 my-auto px-0">
                    Brand Neck Label <br />
                    <small>( W x H : 200px x 200px )</small>
                  </label>
                  <div className="col-9 d-flex align-items-center gap-2">
                    <input
                      onChange={handleFileSelect}
                      id="brandNeckLabel"
                      name="brandNeckLabel"
                      className="form-control"
                      type="file"
                    />
                    {formData?.brandNeckLabel && (
                      <div style={{ position: "relative" }}>
                        <ImgWithSignedUrl
                          path={formData?.brandNeckLabel}
                          height={50}
                          width={50}
                        />
                        <button
                          onClick={() => {
                            deleteNeckLabel(formData?.brandNeckLabel);
                          }}
                          className="btn btn-danger btn-sm p-0 px-1"
                          style={{ position: "absolute", top: 0, left: 0 }}
                        >
                          X
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row mb-2">
                  <label className="col-3 my-auto px-0">
                    Approval Image <br />
                    <small>( W x H : 2400px x 300px )</small>
                  </label>
                  <div className="col-9 d-flex align-items-center gap-2">
                    <input
                      onChange={handleFileSelect}
                      id="approvalImage"
                      name="approvalImage"
                      className="form-control"
                      type="file"
                    />
                    {formData?.approvalImage && (
                      <div style={{ position: "relative", flexShrink: 0 }}>
                        <ImgWithSignedUrl
                          path={formData?.approvalImage}
                          styles={{
                            height: 38,
                            width: "auto",
                            maxWidth: "100%",
                            display: "block",
                          }}
                        />
                        <button
                          onClick={() => {
                            deleteNeckLabel(
                              formData?.approvalImage,
                              "approvalImage",
                            );
                          }}
                          className="btn btn-danger btn-sm p-0 px-1"
                          style={{ position: "absolute", top: 0, left: 0 }}
                        >
                          X
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <hr />
              </div>
              {/* <hr className='mb-3 mt-0' /> */}
              <div className="row">
                <div className="col-md-12">
                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">
                      External Customer ID
                    </label>
                    <div className="col-6 ">
                      <input
                        type="text"
                        value={formData?.externalCustomerId}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            externalCustomerId: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter external customer ID"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">Website</label>
                    <div className="col-6 ">
                      <input
                        type="text"
                        value={formData?.website}
                        onChange={(e) =>
                          setFormData({ ...formData, website: e.target.value })
                        }
                        className="form-control"
                        placeholder="Enter Website"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">Customer Reference</label>
                    <div className="col-6 ">
                      <input
                        type="text"
                        value={formData?.customerReference}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customerReference: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Customer Reference"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">Customer Type</label>
                    <div className="col-6 ">
                      <input
                        type="text"
                        value={formData?.customerType}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customerType: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Customer Type"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">Custom Field 1</label>
                    <div className="col-6 ">
                      <input
                        type="text"
                        value={formData?.customField1}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customField1: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Custom Field 1"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">Custom Field 2</label>
                    <div className="col-6 ">
                      <input
                        type="text"
                        value={formData?.customField2}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customField2: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Customer Type"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">Custom Field 3</label>
                    <div className="col-6 ">
                      <input
                        type="text"
                        value={formData?.customField3}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            customField3: e.target.value,
                          })
                        }
                        className="form-control"
                        placeholder="Enter Customer Type"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <label className="col-5 my-auto px-0">Order Notes</label>
                    <div className="col-6 ">
                      <textarea
                        value={formData?.orderNotes || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            orderNotes: e.target.value,
                          })
                        }
                        className="form-control"
                        rows={3}
                        placeholder="Enter Order Notes"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {isLoading && <Spinner />}
              {/*   Buttons
               ********************************************* */}
              <div className="mt-3 flex-grow-1 d-flex justify-content-end align-items-end">
                <div>
                  <button
                    onClick={() => {
                      setCustomerDetailsModal(false);
                    }}
                    type="button"
                    className="btn btn-secondary me-2 px-1"
                  >
                    CLOSE
                  </button>
                  <button type="submit" className="btn btn-primary">
                    UPDATE
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CustomerDetailsColumn;
